import loadable from '@loadable/component';
import { WithLazyHydration } from '../WithLazyHydration';

const TransporterLoadable = loadable(() => import('./Transporter'), {
  resolveComponent: components => components.Transporter
});

export const Transporter = WithLazyHydration(TransporterLoadable, {
  name: 'Transporter'
});
